/**
 * JS for homepage
 */

// Import components and manager here
import { ComponentManager } from 'js-component-framework';
import jumbotronCarouselConfig
  from '../components/JumbotronCarousel/jumbotronCarouselConfig';
import worldPopCounterConfig
  from '../components/WorldPopCounter/worldPopCounterConfig';

// Import SCSS
import '../../scss/homepage/loader.scss';

// Create instance of the component manager using `wp-starter-theme`
const manager = new ComponentManager('prb-2017');
const components = [
  jumbotronCarouselConfig,
  worldPopCounterConfig,
];

// Initialize components here (commented line below is an example)
document.addEventListener('DOMContentLoaded', () => {
  manager.initComponents(components);
});

// HMR Acceptance
if (module.hot) {
  module.hot.accept();
  manager.initComponents(components);
}



// WEBPACK FOOTER //
// ./client/js/homepage/homepage.js